module.exports = __webpack_public_path__ + "static/media/POL.d7a97aba.jpg";